import { Button, Menu } from '@mantine/core';
import { IconChevronsDown } from '@tabler/icons-react';
import {
  CANDIDATE_STATUS_PRESENTATION,
  type CandidateStatus,
  type CandidateStatusCode,
} from '@entities/candidates';
import classes from './CandidateStatusSelect.module.scss';

type CandidateStatusSelectProps = {
  status: CandidateStatusCode;
  statuses: CandidateStatus[];
  disabled: boolean;
  onStatusChange: (status: CandidateStatusCode) => void;
};

export const CandidateStatusSelect = ({
  status,
  statuses,
  disabled,
  onStatusChange,
}: CandidateStatusSelectProps) => {
  const presentation = CANDIDATE_STATUS_PRESENTATION[status];
  const currentStatus = statuses.find(
    candidateStatus => candidateStatus.name === status
  );
  const currentLabel = currentStatus?.displayName ?? presentation.label;
  const options = statuses.filter(
    candidateStatus => status === 'NEW' || candidateStatus.name !== 'NEW'
  );
  const isDisabled = disabled || options.length === 0;

  const handleChange = (nextStatus: CandidateStatusCode) => {
    if (nextStatus !== status) {
      onStatusChange(nextStatus);
    }
  };

  return (
    <Menu
      position='bottom-start'
      width={280}
      offset={8}
      shadow='md'
      classNames={{ dropdown: classes.dropdown, item: classes.option }}
    >
      <Menu.Target>
        <Button
          aria-label={`Статус кандидата: ${currentLabel}`}
          className={classes.control}
          variant='transparent'
          rightSection={<IconChevronsDown aria-hidden size={20} stroke={2} />}
          disabled={isDisabled}
          style={{
            backgroundColor: presentation.backgroundColor,
            color: presentation.color,
          }}
        >
          {currentLabel}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {options.map(candidateStatus => (
          <Menu.Item
            key={candidateStatus.name}
            data-selected={candidateStatus.name === status}
            onClick={() => handleChange(candidateStatus.name)}
          >
            {candidateStatus.displayName}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
